const gridPaddingInPixels =
  1.2 * parseFloat(getComputedStyle(document.documentElement).fontSize)

export const state = {
  widthInPixels: 400,
}

export const getters = {}

export const mutations = {
  setWidthInPixels(state, pixels) {
    state.widthInPixels = pixels
  },
}

export const actions = {
  updateWidth({ commit, dispatch }, { pixels }) {
    commit(
      'setWidthInPixels',
      Math.min(
        Math.floor(window.innerWidth * 0.8),
        Math.max(gridPaddingInPixels, pixels)
      )
    )
    dispatch('map/resize', null, { root: true })
  },
}
